import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Multiselect from '@vueform/multiselect';
import "@vueform/multiselect/themes/default.css";
import './assets/css/tailwind.css';
// import 'flowbite';
import './assets/css/main.css';

import './assets/v2/css/grid.css';
import './assets/v2/css/app.css';

import moment from 'moment';
moment.locale('ru');
import mitt from 'mitt';
import vClickOutside from "click-outside-vue3";
import snotify from 'vue3-snotify';
import 'vue3-snotify/dist/style.css';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import {
    ArrowCircleLeftIcon,
    ArrowLeftIcon,
    BadgeCheckIcon,
    BellIcon,
    BookOpenIcon,
    CalculatorIcon,
    CashIcon,
    CheckIcon,
    CheckCircleIcon,
    ChevronDownIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
    ChevronUpIcon,
    ClipboardListIcon,
    ClockIcon,
    CollectionIcon,
    DocumentAddIcon,
    DocumentDuplicateIcon,
    DocumentIcon,
    DocumentReportIcon,
    DocumentSearchIcon,
    DocumentTextIcon,
    ExclamationIcon,
    EyeIcon,
    HomeIcon,
    InboxInIcon,
    InformationCircleIcon,
    LibraryIcon,
    LocationMarkerIcon,
    MailIcon,
    OfficeBuildingIcon,
    PencilAltIcon,
    PencilIcon,
    PhoneIcon,
    PlusCircleIcon,
    PlusIcon,
    PlusSmIcon,
    RefreshIcon,
    SaveIcon,
    SearchIcon,
    ShieldCheckIcon,
    StarIcon,
    TemplateIcon,
    TrashIcon,
    TrendingUpIcon,
    UserCircleIcon,
    UserGroupIcon,
    UserIcon,
    UsersIcon,
    ViewListIcon,
    XIcon,
} from '@heroicons/vue/outline'
import BuilderIcon from './components/icons/Builder';
import PdfIcon from './components/icons/Pdf';
import TelegramIcon from './components/icons/Telegram';

import lang from './helpers/vue-lang';
import ru from './helpers/locales/ru';
import kg from './helpers/locales/kg';
import ruValidation from './helpers/locales/validations/ru';
import kgValidation from './helpers/locales/validations/kg';

import validationMixin from "./mixins/validationMixin";
import Loader from './components/Loader';
import PdfFileModal from "./components/modal/PdfFileModal";
import FileModal from "./components/modal/FileModal";
import BlobFileModal from "./components/modal/BlobFileModal";
import BlobModal from "./components/modal/BlobModal";
import LoaderModal from "./components/modal/LoaderModal";

import { VueReCaptcha } from 'vue-recaptcha-v3'

const app = createApp(App)

app.use(store)
app.use(lang, { lang: 'ru', locales: { ru, kg }, validationLocales: {ru: ruValidation, kg: kgValidation} })
app.use(router)
app.use(vClickOutside)
app.use(snotify)
app.use(VueSweetalert2)
app.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA_V3_SITE_KEY, loaderOptions: { autoHideBadge: true } })
app.config.globalProperties.$moment = moment
app.config.globalProperties.$emitter = mitt()
app.component('Multiselect', Multiselect)
app.component('Loader', Loader)
app.component('PdfFileModal', PdfFileModal)
app.component('FileModal', FileModal)
app.component('BlobFileModal', BlobFileModal)
app.component('BlobModal', BlobModal)
app.component('LoaderModal', LoaderModal)

app.component('ArrowCircleLeftIcon', ArrowCircleLeftIcon)
app.component('ArrowLeftIcon', ArrowLeftIcon)
app.component('BadgeCheckIcon', BadgeCheckIcon)
app.component('BellIcon', BellIcon)
app.component('BookOpenIcon', BookOpenIcon)
app.component('CalculatorIcon', CalculatorIcon)
app.component('CashIcon', CashIcon)
app.component('CheckIcon', CheckIcon)
app.component('CheckCircleIcon', CheckCircleIcon)
app.component('ChevronDownIcon', ChevronDownIcon)
app.component('ChevronLeftIcon', ChevronLeftIcon)
app.component('ChevronRightIcon', ChevronRightIcon)
app.component('ChevronUpIcon', ChevronUpIcon)
app.component('ClipboardListIcon', ClipboardListIcon)
app.component('ClockIcon', ClockIcon)
app.component('CollectionIcon', CollectionIcon)
app.component('DocumentAddIcon', DocumentAddIcon)
app.component('DocumentDuplicateIcon', DocumentDuplicateIcon)
app.component('DocumentIcon', DocumentIcon)
app.component('DocumentReportIcon', DocumentReportIcon)
app.component('DocumentSearchIcon', DocumentSearchIcon)
app.component('DocumentTextIcon', DocumentTextIcon)
app.component('ExclamationIcon', ExclamationIcon)
app.component('EyeIcon', EyeIcon)
app.component('HomeIcon', HomeIcon)
app.component('InboxInIcon', InboxInIcon)
app.component('InformationCircleIcon', InformationCircleIcon)
app.component('LibraryIcon', LibraryIcon)
app.component('LocationMarkerIcon', LocationMarkerIcon)
app.component('MailIcon', MailIcon)
app.component('OfficeBuildingIcon', OfficeBuildingIcon)
app.component('PencilAltIcon', PencilAltIcon)
app.component('PencilIcon', PencilIcon)
app.component('PhoneIcon', PhoneIcon)
app.component('PlusCircleIcon', PlusCircleIcon)
app.component('PlusIcon', PlusIcon)
app.component('PlusSmIcon', PlusSmIcon)
app.component('RefreshIcon', RefreshIcon)
app.component('TemplateIcon', TemplateIcon)
app.component('TrashIcon', TrashIcon)
app.component('TrendingUpIcon', TrendingUpIcon)
app.component('SaveIcon', SaveIcon)
app.component('SearchIcon', SearchIcon)
app.component('ShieldCheckIcon', ShieldCheckIcon)
app.component('StarIcon', StarIcon)
app.component('UserCircleIcon', UserCircleIcon)
app.component('UserGroupIcon', UserGroupIcon)
app.component('UserIcon', UserIcon)
app.component('UsersIcon', UsersIcon)
app.component('ViewListIcon', ViewListIcon)
app.component('XIcon', XIcon)

app.component('BuilderIcon', BuilderIcon)
app.component('PdfIcon', PdfIcon)
app.component('TelegramIcon', TelegramIcon)

app.mixin(validationMixin)
app.mount('#app')
